import { Box, GridItem, HStack, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import StyledButton from '../../../../components/StyledButton';
import { useFormItems } from '../../../../hooks/formItems';
import { ZipCodeUtils } from '../../../../utils/ZipCode';
import InformationItems, { ItemCommonProps } from './Information';
import { UserInfoState } from './UserInfoAccordion';

/**
 * 家族連絡先情報状態
 */
type FamilyState = Pick<
  UserInfoState,
  | 'nameOfFamily'
  | 'nameOfFamilyK'
  | 'relationshipOfFamily'
  | 'telOfFamily'
  | 'addressInfoOffamily'
>;

/**
 * 家族連絡先情報
 * @param props -
 * @returns
 */
const FamilyInformation: React.FunctionComponent<ItemCommonProps> = (props) => {
  const form = useFormContext<FamilyState>();
  const { FormInput, FormSelect } = useFormItems<FamilyState>(form);

  const emptyGridItemHidden = useBreakpointValue({ base: true, md: false });

  return (
    <InformationItems name="家族連絡先" panelIndex={2}>
      <GridItem margin={2}>
        <FormInput label="氏名" mode={props.mode} name="nameOfFamily" />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="氏名 (カナ)" mode={props.mode} name="nameOfFamilyK" />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="続柄" mode={props.mode} name="relationshipOfFamily" />
      </GridItem>
      <GridItem margin={2}>
        <FormInput label="電話番号" mode={props.mode} name="telOfFamily" />
      </GridItem>
      <GridItem as={HStack} justifyContent="space-between" margin={2}>
        <FormInput
          formControlProps={{ width: 'calc(100% - 70px)' }}
          inputProps={{ maxLength: 7 }}
          label="郵便番号"
          mode={props.mode}
          name="addressInfoOffamily.zipCode"
        />
        <StyledButton
          marginTop="auto !important"
          hidden={props.mode !== 'edit'}
          onClick={() =>
            ZipCodeUtils.zipCodeToAddress(
              form.getValues('addressInfoOffamily.zipCode')
            ).then((address) => {
              const data =
                Array.isArray(address.data) && address.data.length > 0
                  ? address.data[0]
                  : undefined;
              form.setValue(
                'addressInfoOffamily.address1',
                data?.ja.prefecture
              );
              form.setValue('addressInfoOffamily.address2', data?.ja.address1);
              form.setValue(
                'addressInfoOffamily.address3',
                (data?.ja.address2 || '') + (data?.ja.address3 || '')
              );
            })
          }
        >
          検索
        </StyledButton>
      </GridItem>
      <GridItem hidden={emptyGridItemHidden} />
      <GridItem margin={2}>
        <FormSelect
          label="住所 (都道府県)"
          mode={props.mode}
          name="addressInfoOffamily.address1"
          options={[
            { value: '北海道' },
            { value: '青森県' },
            { value: '岩手県' },
            { value: '宮城県' },
            { value: '秋田県' },
            { value: '山形県' },
            { value: '福島県' },
            { value: '茨城県' },
            { value: '栃木県' },
            { value: '群馬県' },
            { value: '埼玉県' },
            { value: '千葉県' },
            { value: '東京都' },
            { value: '神奈川県' },
            { value: '新潟県' },
            { value: '富山県' },
            { value: '石川県' },
            { value: '福井県' },
            { value: '山梨県' },
            { value: '長野県' },
            { value: '岐阜県' },
            { value: '静岡県' },
            { value: '愛知県' },
            { value: '三重県' },
            { value: '滋賀県' },
            { value: '京都府' },
            { value: '大阪府' },
            { value: '兵庫県' },
            { value: '奈良県' },
            { value: '和歌山県' },
            { value: '鳥取県' },
            { value: '島根県' },
            { value: '岡山県' },
            { value: '広島県' },
            { value: '山口県' },
            { value: '徳島県' },
            { value: '香川県' },
            { value: '愛媛県' },
            { value: '高知県' },
            { value: '福岡県' },
            { value: '佐賀県' },
            { value: '長崎県' },
            { value: '熊本県' },
            { value: '大分県' },
            { value: '宮崎県' },
            { value: '鹿児島県' },
            { value: '沖縄県' },
          ]}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="住所 (市区町村)"
          mode={props.mode}
          name="addressInfoOffamily.address2"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="住所"
          mode={props.mode}
          name="addressInfoOffamily.address3"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInput
          label="住所 (ビル名等)"
          mode={props.mode}
          name="addressInfoOffamily.address4"
        />
      </GridItem>
    </InformationItems>
  );
};

export default FamilyInformation;
